<template>
  <div class="contact-box">
    <div class="select-contact-container" v-if="showTag">
      <van-tag
        v-for="(depId, idx) in selectedDep"
        class="ry-contacts__tag"
        v-if="$store.getters.depListMap[depId]"
        :key="'dep' +  depId"
        :closeable="!disabled"
        size="medium"
        @close="closeDep(depId, idx)">
        <avatar
          style="margin-right: 5px"
          backgroundColor="#2db7f5"
          :username="$store.getters.depListMap[depId].depName"
          :size="20">
        </avatar>
        <span>
          {{$store.getters.depListMap[depId]['depName']}}
      </span>
      </van-tag>

      <van-tag
        v-for="(roleId, idx) in selectedRole"
        type="success"
        class="ry-contacts__tag"
        v-if="$store.getters.rolesMap[roleId]"
        :key="'role' + roleId"
        :closeable="!disabled"
        size="medium"
        @close="closeRole(roleId, idx)">
        <avatar
          style="margin-right: 5px"
          backgroundColor="#FFC107"
          :username="$store.getters.rolesMap[roleId].roleName"
          :size="20">
        </avatar>
        <span>
           {{$store.getters.rolesMap[roleId]['roleName']}}
      </span>
      </van-tag>

      <van-tag
        v-for="(userId, idx) in selectedMember"
        type="info"
        class="ry-contacts__tag"
        v-if="$store.getters.userListMap[userId]"
        :key="'user' + userId"
        :closeable="!disabled"
        size="medium"
        @close="closeUser(userId, idx)">
        <van-image
          style="margin-right: 5px"
          round
          width="20px"
          height="20px"
          :src="$store.getters.userListMap[userId]['headImg']">
        </van-image>
        <span>
        {{$store.getters.userListMap[userId]['nickname']}}
      </span>
      </van-tag>

      <van-tag
        v-for="(userId, idx) in selectedMember"
        type="info"
        class="ry-contacts__tag"
        v-if="$store.getters.leaveMemberListMap[userId]"
        :key="'user' + userId"
        :closeable="!disabled"
        size="medium"
        @close="closeUser(userId, idx)">
        <van-image
          style="margin-right: 5px"
          round
          width="20px"
          height="20px"
          :src="$store.getters.leaveMemberListMap[userId]['headImg']">
        </van-image>
        <span>
        {{$store.getters.leaveMemberListMap[userId]['nickname']}}
      </span>
      </van-tag>

      <van-tag
        v-for="(userId, idx) in selectedExt"
        type="info"
        class="ry-contacts__tag"
        v-if="$store.getters.extMap[userId]"
        :key="'user' + userId"
        :closeable="!disabled"
        size="large"
        @close="closeExt(userId, idx)">
        <van-image
          style="margin-right: 5px"
          round
          width="25px"
          height="25px"
          :src="$store.getters.extMap[userId]['headImg']">
        </van-image>
        <span>
        {{$store.getters.extMap[userId]['orgUserName'] || $store.getters.extMap[userId]['nickname']}}
      </span>
      </van-tag>

      <van-tag
        v-for="(userId, idx) in selectedExt"
        type="info"
        class="ry-contacts__tag"
        v-if="$store.getters.leaveExternalMap[userId]"
        :key="'user' + userId"
        :closeable="!disabled"
        size="large"
        @close="closeExt(userId, idx)">
        <van-image
          style="margin-right: 5px"
          round
          width="25px"
          height="25px"
          :src="$store.getters.leaveExternalMap[userId]['headImg']">
        </van-image>
        <span>
        {{$store.getters.leaveExternalMap[userId]['orgUserName'] || $store.getters.extMap[userId]['nickname']}}
      </span>
      </van-tag>

      <van-button
        v-if="!controlOpen && !disabled"
        :style="{backgroundColor: disabled ? '#F5F7FA' : '#fff'}"
        class="add-contact-btn"
        icon="plus"
        size="small"
        @click="showContactPopup">
      </van-button>
    </div>

    <van-popup
      :key="contactKey"
      class="contact-popup"
      v-model="showContact"
      :overlay="false"
      get-container="body"
      :style="{ height: '100%', width: '100%' }"
      position="right">

      <MemberFieldSelectContacts
        ref="memberFieldSelectContacts"
        v-if="formSet"
        :selectedUser="selectedMember"
        :selectedExt="selectedExt"
        :fieldId="fieldId"
        :custom-tabs="customTabs"
        :formSet="formSet"
        :hasMember="hasMember"
        :hasRole="hasRole"
        :hasExternal="hasExt"
        :hasLabel="hasLabel"
        :radioMember="!multiple"
        @selectedComplete="selectedMemberComplete"
        @onCancel="onCancel">
      </MemberFieldSelectContacts>

      <RyContact
        v-else
        ref="ryContact"
        :key="contactKey"
        :user-id="userId"
        :company-id="companyId"
        :hasMember="hasMember"
        :hasDep="hasDep"
        :hasRole="hasRole"
        :has-ext="hasExt"
        :has-label="hasLabel"
        :has-current="hasCurrent"
        :multiple="multiple"
        :selectedDep="selectedDep"
        :selectedRole="selectedRole"
        :selectedMember="selectedMember"
        :selected-ext="selectedExt"
        :selected-label="selectedLabel"
        :disableDep="disableDep"
        :disableRole="disableRole"
        :disableMember="disableMember"
        :disable-ext="disableExt"
        :disable-label="disableLabel"
        :removeDep="removeDep"
        :removeRole="removeRole"
        :removeMember="removeMember"
        :remove-ext="removeExt"
        :remove-label="removeLabel"
        :available-members="availableMembers"
        :available-deps="availableDeps"
        :available-roles="availableRoles"
        :available-ext="availableExt"
        :customTabs="customTabs"
        :formSet="formSet"
        :fieldId="fieldId"
        @selectedComplete="selectedComplete"
        @onCancel="onCancel">
      </RyContact>
    </van-popup>
  </div>
</template>

<script>
  import Avatar from 'vue-avatar'
  export default {
    components: {
      Avatar
    },
    props: {
      formSet: Object,
      showTag: {
        type: Boolean,
        default: true
      },
      // 是否禁用
      disabled: {
        type: Boolean,
        default: false
      },
      // 子表单内选人使用，唯一标识,必传
      uniqueId: {
        type: String,
        default: 'default'
      },
      fieldId: String,
      field: Object,
      userId: {
        type: Number,
        default: null
      },
      companyId: {
        type: String,
        default: ''
      },
      // 是否有人员选择
      hasMember: {
        type: Boolean,
        default: true
      },
      // 是否有部门选择
      hasDep: {
        type: Boolean,
        default: true
      },
      // 是否有角色
      hasRole: {
        type: Boolean,
        default: true
      },
      // 是否有外部联系人
      hasExt: {
        type: Boolean,
        default: true
      },
      // 是否有外部联系人标签
      hasLabel: {
        type: Boolean,
        default: true
      },

      hasCurrent: {
        type: Boolean,
        default: true
      },

      // 是否多选
      multiple: {
        type: Boolean,
        default: true
      },
      // 上下文对象
      context: Object | null,
      // 选中的部门
      selectedDep: {
        type: Array,
        default: () => []
      },
      // 选中的角色
      selectedRole: {
        type: Array,
        default: () => []
      },
      // 选中的人员
      selectedMember: {
        type: Array,
        default: () => []
      },
      // 选中的外部联系人
      selectedExt: {
        type: Array,
        default: () => []
      },
      // 选中的外部联系人标签
      selectedLabel: {
        type: Array,
        default: () => []
      },

      // 移除的部门
      removeDep: {
        type: Array,
        default: () => []
      },
      // 移除的角色
      removeRole: {
        type: Array,
        default: () => []
      },
      // 移除的人员
      removeMember: {
        type: Array,
        default: () => []
      },
      // 移除的外部联系人
      removeExt: {
        type: Array,
        default: () => []
      },
      // 移除的外部联系人标签
      removeLabel: {
        type: Array,
        default: () => []
      },

      // 不可选的部门
      disableDep: {
        type: Array,
        default: () => []
      },
      // 不可选的角色
      disableRole: {
        type: Array,
        default: () => []
      },
      // 不可选的人员
      disableMember: {
        type: Array,
        default: () => []
      },
      // 不可选的外部联系人
      disableExt: {
        type: Array,
        default: () => []
      },
      // 不可选的外部联系人标签
      disableLabel: {
        type: Array,
        default: () => []
      },

      // 部门可选择的 idList
      availableDeps: {
        type: Array,
        default: () => []
      },
      // 成员可选择的 idList
      availableMembers: {
        type: Array,
        default: () => []
      },
      // 角色可选择的 idList
      availableRoles: {
        type: Array,
        default: () => []
      },
      // 外部联系人可选择的 idList
      availableExt: {
        type: Array,
        default: () => []
      },
      // 是否外部控制选人打开
      controlOpen: {
        type: Boolean,
        default: false
      },
      /*
      * 自定义标签tab
      * {
      *   key: '',
      *   name: ''
      * }
      * */
      customTabs: {
        type: Array,
        default: () => []
      },
    },
    data() {
      return {
        contactKey: Math.random(),
        showContact: false,
        clickUniqueId: '',
      }
    },
    created() {
      this.contactKey = this.fieldId ? this.fieldId : Math.random()
    },
    methods: {
      open() {
        this.showContactPopup()
      },
      showContactPopup() {
        if (this.disabled) return
        this.contactKey = this.fieldId ? this.fieldId : Math.random()
        this.clickUniqueId = this.uniqueId
        if (this.field) this.field.showContact = true
        this.showContact = true
        setTimeout(() => {
          if (this.$refs.memberFieldSelectContacts) {
            this.$refs.memberFieldSelectContacts.open()
          }
        },500)
      },
      selectedComplete(selected) {
        console.log('selected111', selected, this.fieldId)
        if (this.field) this.field.showContact = false
        this.showContact = false
        this.emitChange()
        this.$emit('selectedComplete', selected)
        console.log('selected222', selected)
      },
      onCancel() {
        if (this.field) this.field.showContact = false
        this.showContact = false
      },

      selectedMemberComplete(selected) {
        console.log('selected111', selected, this.fieldId)
        if (this.field) this.field.showContact = false
        this.showContact = false
        this.emitChange()
        // this.$emit('selectedComplete', selected)
      },
      closeUser(userId, idx) {
        if (this.selectedMember[idx] !== userId) {
          idx = this.selectedMember.indexOf(userId)
        }
        this.selectedMember.splice(idx, 1)
        this.$emit('deleteUser', {
          member: userId,
          role: null,
          depart: null,
          external: null,
          label: null
        })
        this.emitChange()
      },
      closeDep(depId, idx) {
        if (this.selectedDep[idx] !== depId) {
          idx = this.selectedDep.indexOf(depId)
        }
        this.selectedDep.splice(idx, 1)
        this.emitChange()
      },
      closeRole(roleId, idx) {
        if (this.selectedRole[idx] !== roleId) {
          idx = this.selectedRole.indexOf(roleId)
        }
        this.selectedRole.splice(idx, 1)
        this.emitChange()
      },
      closeExt(userId, idx) {
        if (this.selectedExt[idx] !== userId) {
          idx = this.selectedExt.indexOf(userId)
        }
        this.selectedExt.splice(idx, 1)
        console.log('closeExt', userId)
        this.$emit('deleteUser', {
          member: null,
          role: null,
          depart: null,
          external: userId,
          label: null
        })
        this.emitChange()
      },

      emitChange() {
        this.$emit('change', {
          member: this.selectedMember,
          role: this.selectedRole,
          depart: this.selectedDep,
          external: this.selectedExt,
          label: this.selectedLabel
        })
      }
    },
    watch: {
      'field.showContact'() {
        if (this.uniqueId !== 'default' && this.clickUniqueId !== this.uniqueId) {
          return
        }
        if (this.field && this.showContact !== this.field.showContact) {
          this.showContact = this.field.showContact
        }
        if (!this.showContact) {
          this.clickUniqueId = ''
        }
      },
      showContact() {
        if (this.field && this.field.showContact !== this.showContact) {
          this.field.showContact = this.showContact
        }
      }
    }
  }
</script>

<style lang="less">

  .contact-box {

    .select-contact-container {
      display: flex;
      flex-wrap: wrap;
      align-items: center;

      .van-tag {
        background-color: #f4f4f5;
        border-color: #e9e9eb;
        color: #909399;
        font-size: 12px;
        margin-right: 10px;
        margin-bottom: 5px;

        > span {
          margin-right: 5px;
        }
      }

      .add-contact-btn {
        border-radius: 50%;
        width: 32px;
        min-width: 32px;
        padding: 0;
        margin-bottom: 5px;
      }
    }

    .contact-popup {
      width: 100%;
      height: 100%;
    }
  }
</style>
